<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 19 19"
    fill="none"
  >
    <!-- eslint-disable max-len -->
    <path
      d="M18.5 9.5C18.5 14.4706 14.4706 18.5 9.5 18.5C4.52944 18.5 0.5 14.4706 0.5 9.5C0.5 4.52944 4.52944 0.5 9.5 0.5C10.9121 0.5 12.2482 0.825189 13.4375 1.40476M16.8125 3.875L8.9375 11.75L6.6875 9.5"
      stroke="#595959"
      stroke-width="1"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <!-- eslint-enable max-len -->
  </svg>
</template>
